<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div>
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mt-6">
          <label class="label-input">Card 1</label>
          <div class="group-item">
            <UploadImage
              @callback="obj => handleUploadImageCard(obj, 'card1')"
              :image="{ imageSrc: fields.card1.image }"
              :height="`100`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveImageCard('card1')"
            />
            <v-text-field class="mt-6" v-model="fields.card1.text" label="Text" />
            <v-row>
              <v-col cols="6">
                <v-text-field v-model="fields.card1.button.text" label="Button Text" />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="number"
                  v-model.number="fields.card1.button.radius"
                  label="Button Radius"
                  min="0"
                  suffix="px"
                  :rules="[v => v >= 0 || 'Button Radius must be greater than or equal 0']"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Card 2</label>
          <div class="group-item">
            <UploadImage
              @callback="obj => handleUploadImageCard(obj, 'card2')"
              :image="{ imageSrc: fields.card2.image }"
              :height="`100`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveImageCard('card2')"
            />
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Card 3</label>
          <div class="group-item">
            <UploadImage
              @callback="obj => handleUploadImageCard(obj, 'card3')"
              :image="{ imageSrc: fields.card3.image }"
              :height="`100`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveImageCard('card3')"
            />
            <v-text-field class="mt-6" v-model="fields.card3.text" label="Text" />
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Card 4</label>
          <div class="group-item">
            <UploadImage
              @callback="obj => handleUploadImageCard(obj, 'card4')"
              :image="{ imageSrc: fields.card4.image }"
              :height="`100`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveImageCard('card4')"
            />
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <div>
              <div class="font-weight-medium">Spacing</div>
              <v-row>
                <v-col cols="6">
                  <v-checkbox v-model="fields.topPadding" label="Top Padding" dense hide-details />
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="fields.bottomPadding" label="Bottom Padding" dense hide-details />
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <div class="font-weight-medium mb-3 mb-2">Container Colors</div>
              <v-row>
                <v-col md="12" cols="12">
                  <ColorPicker
                    v-model="fields.backgroundColor"
                    name="backgroundColor"
                    label="Background Color"
                    default-color="#ffffff"
                  />
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <div class="font-weight-medium mb-3 mb-2">Card 1 Colors</div>
              <v-row>
                <v-col md="3" cols="12">
                  <ColorPicker
                    v-model="fields.card1.backgroundColor"
                    name="card1BackgroundColor"
                    label="Background Color"
                    default-color="#01ae74"
                  />
                </v-col>
                <v-col md="3" cols="12">
                  <ColorPicker
                    v-model="fields.card1.textColor"
                    name="card1TextColor"
                    label="Text Color"
                    default-color="#ffffff"
                  />
                </v-col>
                <v-col md="3" cols="12">
                  <ColorPicker
                    v-model="fields.card1.button.backgroundColor"
                    name="card1ButtonBackgroundColor"
                    label="Button Background Color"
                    default-color="#464646"
                  />
                </v-col>
                <v-col md="3" cols="12">
                  <ColorPicker
                    v-model="fields.card1.button.textColor"
                    name="card1ButtonTextColor"
                    label="Button Text Color"
                    default-color="#ffffff"
                  />
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <div class="font-weight-medium mb-3 mb-2">Card 3 Colors</div>
              <v-row>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields.card3.backgroundColor"
                    name="card3BackgroundColor"
                    label="Background Color"
                    default-color="#efefef"
                  />
                </v-col>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields.card3.textColor"
                    name="card3TextColor"
                    label="Text Color"
                    default-color="#6d6d6d"
                  />
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <div class="font-weight-medium mb-3 mb-2">Card 4 Colors</div>
              <v-row>
                <v-col md="12" cols="12">
                  <ColorPicker
                    v-model="fields.card4.backgroundColor"
                    name="card4BackgroundColor"
                    label="Background Color"
                    default-color="#464646"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import ColorPicker from './common/color-picker.vue';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

export default {
  name: 'banner-basic-section-editor',
  components: {
    UploadImage,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Banner Basic Section',
        enableAnchor: false,
        topPadding: true,
        bottomPadding: true,
        backgroundColor: '#ffffff',
        card1: {
          image: '',
          text: 'At the heart of it all, we lead with purpose.',
          backgroundColor: '#01ae74',
          textColor: '#ffffff',
          button: {
            text: 'LEARN MORE',
            textColor: '#ffffff',
            backgroundColor: '#464646',
            radius: 5,
          },
        },
        card2: {
          image: '',
        },
        card3: {
          image: '',
          text: 'Stripe Climate member.',
          backgroundColor: '#efefef',
          textColor: '#6d6d6d',
        },
        card4: {
          image: '',
          backgroundColor: '#464646',
        },
      },
    };
  },
  mounted() {
    if (this.sectionEditor.sectionExtract) {
      this.fields = {
        ...this.fields,
        ...this.sectionEditor.sectionExtract,
      };
    }
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal.sectionExtract) {
          this.fields = {
            ...this.fields,
            ...newVal.sectionExtract,
          };
        }
      },
      deep: true,
    },
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionBannerBasic(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImageCard(obj, cardName) {
      this.fields[cardName].image = obj.imageSrc;
    },
    handleRemoveImageCard(cardName) {
      this.fields[cardName].image = '';
    },
  },
};
</script>

<style scoped lang="scss">
.ck-editor__editable {
  min-height: 100px;
}
.thumbnail-text {
  flex: 1;
  p {
    margin: 0 !important;
  }
}
.item-thumbnail {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
